import { isSameDay } from 'date-fns';
import type { ProgramListEvent } from 'models';
import { useMemo } from 'react';
import { WidgetItem } from 'ui';
import { EventActionsSocial, useIsLiveStatus } from 'features/events';

type P = {
  getPathToEventDetail: (id: string) => string;
  invitation: ProgramListEvent;
};

const RailsInvitationWidgetItem = ({ getPathToEventDetail, invitation }: P) => {
  const { author, endTime, id, name, startTime, status } = invitation;
  const isLive = useIsLiveStatus({ endTime, startTime, status });

  const timeConfig = useMemo(
    () => ({
      options: {
        display: isSameDay(startTime, new Date()) ? ('time' as const) : ('full' as const),
        mode: 'default' as const,
      },
      time: startTime,
    }),
    [startTime],
  );

  return (
    <WidgetItem
      activeDate={new Date()}
      description={name}
      item={<EventActionsSocial authorId={author.id} event={invitation} />}
      path={getPathToEventDetail(id)}
      tags={isLive ? ['live'] : undefined}
      timeConfig={timeConfig}
    />
  );
};

export default RailsInvitationWidgetItem;
